import { createAction } from '@reduxjs/toolkit';

import type { CanvasConfiguration } from 'domains/canvases';
import type { ExpandedCartProduct } from 'domains/cart_products';

const pending = createAction<number>('cartProducts/editCartProduct/pending');
const cartProductReady = createAction<ExpandedCartProduct>(
  'cartProducts/editCartProduct/cartProductReady'
);
const canvasReady = createAction<CanvasConfiguration>('cartProducts/editCartProduct/canvasReady');
const setupComplete = createAction('cartProducts/editCartProduct/setupComplete');
const rejected = createAction('cartProducts/editCartProduct/rejected');

export default {
  pending,
  cartProductReady,
  canvasReady,
  setupComplete,
  rejected,
};
